export const environment = {
	// API_URL: 'https://34.218.6.116:8000/api'
	API_URL: '/obd-api'
};
